import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';
import * as fromOpenAccount from '../../reducers/open-account/open-account.reducer';

export const selectOpenAccountState = createSelector(
  fromFeature.getOpenAccountState,
  (state) => state,
);

export const selectOpenAccountResponse = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getOpenAccountResponse,
);

export const selectSubmitMetricsID = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getSubmitMetricsID,
);

export const selectSettlementFundChoice = createSelector(
  selectOpenAccountState,
  fromOpenAccount.getSettlementFundChoice,
);
